import { render, staticRenderFns } from "./PublishList.vue?vue&type=template&id=2bc6b1f8&scoped=true&"
import script from "./PublishList.vue?vue&type=script&lang=js&"
export * from "./PublishList.vue?vue&type=script&lang=js&"
import style0 from "./PublishList.vue?vue&type=style&index=0&id=2bc6b1f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6b1f8",
  null
  
)

export default component.exports